import React from 'react';
import { Popover, Space, Typography, Avatar } from 'antd';
import moment from 'moment-timezone';
import { getAvatarColor, getProfileUrl } from '../../../utility/utility';
import FeatherIcon from 'feather-icons-react';
const Modified = ({ updatedAt, lastModifiedBy, DateAndTimeFormat }) => {
    return (
        <Popover
            content={
                <Space direction="vertical" size={'small'}>
                    {lastModifiedBy && (
                        <>
                            <Typography.Text>
                                <Typography.Text strong>Name: </Typography.Text>
                                {lastModifiedBy.firstName} {lastModifiedBy.lastName}
                            </Typography.Text>
                            <Typography.Text>
                                <Typography.Text strong>Email: </Typography.Text>
                                {lastModifiedBy.email}
                            </Typography.Text>

                            {lastModifiedBy?.departments?.length && (
                                <Typography.Text>
                                    <Typography.Text strong>Department(s): </Typography.Text>
                                    {lastModifiedBy.departments.map((department) => department.name).join(', ')}
                                </Typography.Text>
                            )}
                        </>
                    )}
                    <Typography.Text>
                        <Typography.Text strong>Modified At: </Typography.Text>
                        {moment(updatedAt).format(DateAndTimeFormat)}
                    </Typography.Text>
                </Space>
            }
        >
            <Space
                direction="horizontal"
                style={{
                    cursor: 'pointer',
                }}
            >
                {moment(updatedAt).fromNow()}
                {lastModifiedBy && (
                    <Avatar
                        size={'default'}
                        src={getProfileUrl({
                            currentUser: lastModifiedBy,
                        })}
                        // style={{
                        //     backgroundColor: getAvatarColor(lastModifiedBy.username),
                        //     // can you change the text to some gray

                        // }}
                        icon={<FeatherIcon icon="user" size={12} />}
                    >
                        {lastModifiedBy?.firstName.slice(0, 1)} {lastModifiedBy?.lastName.slice(0, 1)}
                    </Avatar>
                )}
            </Space>
        </Popover>
    );
};
export default Modified;
